import { useRef } from 'react';

export const useDataToRef = <T extends object>(data: T) => {
	const ref = useRef(data);
	ref.current = data;

	return ref;
};
